import { cmvrCenterAddComponent } from "./cmvr-center-add.component";

export const cmvrCenterAdd = angular
  .module("components.cmvrCenter.cmvrCenterAdd", [])
  .component("cmvrCenterAdd", cmvrCenterAddComponent)
  .config(($stateProvider) => {
    "ngInject";

    $stateProvider.state("cmvrCenterAdd", {
      parent: "app",
      parentState: "cmvrCenterList",
      url: "/cmvr-centers/add",
      breadcrumbName: "Add new CMVR Center",
      component: "cmvrCenterAdd",
      resolve: {},
    });
  }).name;



// WEBPACK FOOTER //
// ./src/app/components/cmvr-center/cmvr-center-add/cmvr-center-add.module.js